// A setting the driver's manifest declares for this config's role: the key is fixed (a
// label), the control matches the declared kind — a switch for "bool"
// (IntegratorConfigSettingSwitchCell template), a text field for everything else
// (IntegratorConfigSettingCell template). Values write into the config's configValues.
class IntegratorConfigSettingCell extends UITableViewCell
{
    private keyLabel: MUILabel = null;
    private valueTextField: MUITextField = null;
    private valueSwitch: MUISwitchButton = null;

    awakeFromHTML() {
        this.keyLabel = MUIOutlet(this, "key-lbl", "MUILabel");

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        if (this.valueTextField != null) {
            this.valueTextField.setOnChangeText(this, function(this:IntegratorConfigSettingCell, tf:MUITextField, value:string) {
                this.writeValue(value);
            });
        }

        this.valueSwitch = MUIOutlet(this, "value-sw", "MUISwitchButton");
        if (this.valueSwitch != null) {
            this.valueSwitch.setOnChangeValue(this, function(this:IntegratorConfigSettingCell, control: MUISwitchButton, on: boolean) {
                this.writeValue(on);
            });
        }

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _config: IntegratorConfig = null;
    private _key: string = null;

    setSetting(setting: any, config: IntegratorConfig) {
        this._config = config;
        this._key = setting["key"];
        this.keyLabel.text = this._key;

        let v = (config.configValues || {})[this._key];
        if (this.valueSwitch != null) {
            this.valueSwitch.on = v == true || v == "true" || v == "1";
        }
        if (this.valueTextField != null) {
            this.valueTextField.text = v == null ? "" : (typeof v == "string" ? v : JSON.stringify(v));
        }
    }

    private writeValue(value: any) {
        if (this._config == null || this._key == null) return;
        let values = this._config.configValues || {};
        if (typeof value == "string") {
            let t = value.trim();
            if (t.length > 0 && (t.charAt(0) == "[" || t.charAt(0) == "{")) {
                try { value = JSON.parse(t); } catch (e) { /* keep the raw text while typing */ }
            }
        }
        values[this._key] = value;
        this._config.configValues = values;
    }
}
